import axios from '@/plugins/axios';
import qs from 'qs';
import utils from '@/stores/utils';
import slugify from "slugify";
import { migrateCatalogEntryFormatFilter } from "@/utils/apiFilterParams";

let DEFAULT_SHIPMENT_PREPARED_ALGORYTHM =
    'exports.handler = async (event) => {\n\n    let unit_amount_excl_vat = 0\n\n    if (event.shipment.items_count < 200) {\n        unit_amount_excl_vat = 0.1 * event.shipment.items_count\n    } else {\n        if (event.shipment.products_count < 5) {\n            unit_amount_excl_vat = 20\n        } else {\n            unit_amount_excl_vat = 0.1 * event.shipment.items_count\n        }\n    }\n\n    body = {\n        "line":\n        {\n            "label": event.shipment.shipment_id + " - Préparation de " + event.shipment.items_count + " bouteilles",\n            "vat_rate": 0.2,\n            "unit_amount_excl_vat": unit_amount_excl_vat,\n            "billing_date": event.shipment.prepared_date,\n            "count": 1,\n        }\n    }\n    return {\n        statusCode: 200,\n        body: JSON.stringify(body)\n    };\n}';
let DEFAULT_SHIPMENT_DELIVERED_ALGORYTHM =
    'exports.handler = async (event) => {\n\n    if (!event.shipment.deliverysite) {\n        return {\n            statusCode: 400,\n            body: JSON.stringify({ error: "L\'adresse de livraison du client final n\'est pas renseignée sur l\'expédition" })\n        };\n    }\n    address = event.shipment.deliverysite_data.address;\n\n    if (!address) {\n        return {\n            statusCode: 400,\n            body: JSON.stringify({ error: "Veuillez renseigner l\'adresse de livraison du client final afin de pouvoir établir un prix" })\n        };\n    }\n\n    if (!address.postal_code) {\n        return {\n            statusCode: 400,\n            body: JSON.stringify({ error: "Veuillez renseigner un code postal sur l\'adresse de livraison du client final afin de pouvoir établir un prix"})\n        };\n    }\n    \n    if (!address.postal_code || address.postal_code.length < 2) {\n        return {\n            statusCode: 400,\n            body: JSON.stringify({ error: "Veuillez renseigner un code postal valide ( au moins 2 charactères) sur l\'adresse de livraison du client final afin de pouvoir établir un prix"})\n        };\n    }\n\n    if (["77", "78", "91", "95"].indexOf(address.postal_code.substr(0, 2)) != -1) {\n        if (event.shipment.items_count < 66) {\n            unit_amount_excl_vat = 55;\n        } else {\n            unit_amount_excl_vat = 70;\n        }\n    }\n    else if (["75", "92", "93", "94"].indexOf(address.postal_code.substr(0, 2)) != -1) {\n        if (event.shipment.items_count < 31) {\n            unit_amount_excl_vat = 18;\n        }\n        else if (event.shipment.items_count < 73) {\n            unit_amount_excl_vat = 21;\n        } else {\n            unit_amount_excl_vat = 0.28 * event.shipment.items_count;\n        }\n    } else {\n        unit_amount_excl_vat = 70;\n    }\n    body = {\n        "line": {\n            "label": event.shipment.shipment_id + " - Expédition de " + event.shipment.items_count + " bouteilles",\n            "vat_rate": 0.2,\n            "unit_amount_excl_vat": unit_amount_excl_vat,\n            "billing_date": event.shipment.delivered_date,\n            "quantity": 1,\n        }\n    }\n    const response = {\n        statusCode: 200,\n        body: JSON.stringify(body)\n    };\n    return response;\n}';
let DEFAULT_STOCK_ALGORYTHM =
    'exports.handler = async (event) => {\n    let total_amount_excl_vat = 0\n    let total_stock_count = 0\n\n    for (upc in event.products) {\n        product = event.products[upc];\n        if (product.stock_count < 100) {\n            unit_amount_excl_vat = 0.1 * product.stock_count\n        } else if (product.stock_count < 200) {\n            unit_amount_excl_vat = 10;\n        } else if (product.stock_count < 300) {\n            unit_amount_excl_vat = 20;\n        } else if (product.stock_count < 600) {\n            unit_amount_excl_vat = 30;\n        } else {\n            unit_amount_excl_vat = 60;\n        }\n        total_amount_excl_vat += unit_amount_excl_vat\n        total_stock_count += product.stock_count\n    }\n    if (!total_amount_excl_vat) {\n        return {\n            statusCode: 200,\n            body: JSON.stringify({})\n        };\n    }\n    body = {\n        "line":\n        {\n            "label": "Stock - " + total_stock_count + " bouteilles",\n            "vat_rate": 0.2,\n            "unit_amount_excl_vat": total_amount_excl_vat,\n            "quantity": 1,\n        }\n    }\n    return {\n        statusCode: 200,\n        body: JSON.stringify(body)\n    };\n\n}';
let DEFAULT_RECEIPT_HANDLED_ALGORYTHM =
    'exports.handler = async (data) => {\n    let unit_amount_excl_vat = 0;\n\n    // Calcul du titre de la ligne de facturation\n    let label = data.receipt.receipt_id + " - Réception de " + data.receipt.items_count + " bouteilles";\n\n    // Tarification dépendante du nombre d\'éléments dans la réception\n    if (data.receipt.items_count < 120) {\n        unit_amount_excl_vat = 0.1 * data.receipt.items_count;\n    } else if (data.receipt.products_count < 5) {\n       unit_amount_excl_vat = 12;\n    } else {\n        unit_amount_excl_vat = 0.1 * data.receipt.items_count;\n    }\n\n    body = {\n        "line" : {\n                "label": label,\n                "count": 1,\n                "unit_amount_excl_vat": unit_amount_excl_vat,\n                "vat_rate": 0.2, // 20%\n                "billing_date": data.receipt.handled_date,\n            }\n    };\n    return {\n        statusCode: 200,\n        body: JSON.stringify(body)\n    };\n};';
let DEFAULT_SHIPMENT_PICKEDUP_ALGORYTHM =
    'exports.handler = async (data) => {\n    let unit_amount_excl_vat = 0;\n\n    // Calcul du titre de la ligne de facturation\n    let label = data.receipt.receipt_id + " - Réception de " + data.receipt.items_count + " bouteilles";\n\n    // Tarification dépendante du nombre d\'éléments dans la réception\n    if (data.receipt.items_count < 120) {\n        unit_amount_excl_vat = 0.1 * data.receipt.items_count;\n    } else if (data.receipt.products_count < 5) {\n       unit_amount_excl_vat = 12;\n    } else {\n        unit_amount_excl_vat = 0.1 * data.receipt.items_count;\n    }\n\n    body = {\n        "line" : {\n                "label": label,\n                "count": 1,\n                "unit_amount_excl_vat": unit_amount_excl_vat,\n                "vat_rate": 0.2, // 20%\n                "billing_date": data.receipt.handled_date,\n            }\n    };\n    return {\n        statusCode: 200,\n        body: JSON.stringify(body)\n    };\n};';
let EMPTY_ALGORYTHM =
    'exports.handler = async (data) => {\n    let body = {\n        "line" : {\n                "label": "Empty label",\n                "quantity": 1,\n                "unit_amount_excl_vat": 10,\n                "vat_rate": 0.2,                   \n                "billing_date": null,\n            }\n    };\n    return {\n        statusCode: 200,\n        body: JSON.stringify(body)\n    };\n};';

const DEFAULT_CUSTOM_ALGORYTHMS = {
    "receipt-handled": DEFAULT_RECEIPT_HANDLED_ALGORYTHM,
    "shipment-prepared": DEFAULT_SHIPMENT_PREPARED_ALGORYTHM,
    "shipment-delivered": DEFAULT_SHIPMENT_DELIVERED_ALGORYTHM,
    "shipment-pickedup": DEFAULT_SHIPMENT_PICKEDUP_ALGORYTHM,
    stock: DEFAULT_STOCK_ALGORYTHM,
    default: EMPTY_ALGORYTHM,
};

const state = {
    catalog: null,
    catalog_loading: false,
    catalog_loading_errors: null,
    catalog_saving: false,
    catalog_saving_errors: {},
    catalog_deleting: false,
    catalog_deleting_errors: null,

    catalogentry: false,
    catalogentry_loading: false,
    catalogentry_loading_errors: null,
    catalogentry_saving: false,
    catalogentry_saving_errors: {},
    catalogentry_archiving: false,
    catalogentry_archiving_errors: null,

    catalogentries: null,
    catalogentries_count: 0,
    catalogentries_loading: false,
    catalogentries_filters: { offset: 0, limit: 20 },
    catalogentries_loading_errors: null,

    catalogassignments: [],
    catalogassignments_count: 0,
    catalogassignments_filters: {},
    catalogassignments_loading: false,
    catalogassignments_loading_errors: null,

    products: [],
    products_loading: false,
    products_loading_errors: null,
    products_search: null,

    test_errors: null,
    test_params: {},
    test_receipts: [],
    test_receipts_loading: false,
    test_receipts_errors: null,
    test_shipments: [],
    test_shipments_loading: false,
    test_shipments_errors: null,
    testing_function: false,

    generating_code: false,

    categories: [],
    categories_filters: {},
    categories_loading: false,
    categories_loading_errors: null,
};


const mutations = {

    updateProducts(state, products) {
        state.products = products;
        state.products_loading = false;
        state.products_loading_errors = null;
    },
    updateProductsLoading(state, loading) {
        state.products_loading = loading;
        state.products_loading_errors = null;
        state.products = [];
    },
    updateProductsLoadingErrors(state, errors) {
        state.products_loading_errors = errors;
        state.products_loading = false;
    },

    updateCatalog(state, catalog) {
        state.catalog = catalog;
        state.catalogentries = [];
        state.catalogentries_count = 0;
        state.catalog_saving_errors = {};
    },
    updateCatalogLoading(state, loading) {
        state.catalog_loading = loading;
    },
    updateCatalogLoadingErrors(state, errors) {
        state.catalog_loading_errors = errors;
    },
    updateCatalogSaving(state, saving) {
        state.catalog_saving = saving;
    },
    updateCatalogSavingErrors(state, errors) {
        state.catalog_saving = false;
        state.catalog_saving_errors = errors;
    },
    updateCatalogDeleting(state, deleting) {
        state.catalog_deleting = deleting;
    },
    updateCatalogDeletingErrors(state, errors) {
        state.catalog_deleting_errors = errors;
    },

    updateCatalogEntryLoading(state, loading) {
        state.catalogentry_loading = loading;
    },
    updateCatalogEntryLoadingErrors(state, errors) {
        state.catalogentry_loading_errors = errors;
    },
    updateCatalogEntrySaving(state, saving) {
        state.catalogentry_saving = saving;
    },
    updateCatalogEntrySavingErrors(state, errors) {
        state.catalogentry_saving_errors = errors;
    },
    updateCatalogEntryArchiving(state, deleting) {
        state.catalogentry_archiving = deleting;
    },
    updateCatalogEntryArchivingErrors(state, errors) {
        state.catalogentry_archiving_errors = errors;
    },

    updateCatalogEntries(state, catalogentries) {
        state.catalogentries = catalogentries;
    },
    updateCatalogEntriesCount(state, count) {
        state.catalogentries_count = count;
    },
    updateCatalogEntriesFilters(state, filters) {
        state.catalogentries_filters = migrateCatalogEntryFormatFilter(filters);
    },
    updateCatalogEntriesLoading(state, loading) {
        state.catalogentries_loading = loading;
    },
    updateCatalogEntriesLoadingErrors(state, errors) {
        state.catalogentries_loading_errors = errors;
    },

    updateCatalogAssignments(state, catalogassignments) {
        state.catalogassignments = catalogassignments;
    },
    updateCatalogAssignmentsCount(state, count) {
        state.catalogassignments_count = count;
    },
    updateCatalogAssignmentsLoading(state, loading) {
        state.catalogassignments_loading = loading;
    },
    updateCatalogAssignmentsLoadingErrors(state, errors) {
        state.catalogassignments_loading_errors = errors;
    },

    updateCatalogAssignmentDeleting(state, deleting) {
        state.catalog_deleting_assignment = deleting;
    },
    updateCatalogAssignmentDeletingErrors(state, errors) {
        state.catalog_deleting_assignments_errors = errors;
    },

    updateTestReceipts(state, receipts) {
        state.test_receipts = receipts;

        if (!state.test_params.receipt_id && receipts && receipts.length) {
            state.test_params.receipt_id = receipts[0].receipt_id;
        }
    },
    updateTestReceiptsLoading(state, loading) {
        state.test_receipts_loading = loading;
    },
    updateTestReceiptsLoadingErrors(state, errors) {
        state.test_receipts_loading_errors = errors;
    },
    updateTestShipments(state, shipments) {
        state.test_shipments = shipments;
        if (!state.test_params.shipment_id && shipments && shipments.length) {
            state.test_params.shipment_id = shipments[0].shipment_id;
        }
    },
    updateFunnction(state, funnction) {
        state.catalogentry = Object.assign({}, state.catalogentry, {
            function: funnction
        })
    },
    updateTestParams(state, test_params) {
        state.test_params = test_params;
    },
    updateTestShipmentsLoading(state, loading) {
        state.test_shipments_loading = loading;
    },
    updateTestShipmentsLoadingErrors(state, errors) {
        state.test_shipments_loading_errors = errors;
    },
    updateTestingFunction(state, testing) {
        state.testing_function = testing;
    },
    updateGeneratingCode(state, generating) {
        state.generating_code = generating;
    },

    updateCatalogEntry(state, catalogentry) {
        state.catalogentry = catalogentry;
        if (!catalogentry.id) {
            state.catalogentry.algorythm = catalogentry.algorythm || 'fixed';
            state.catalogentry.recurring = catalogentry.recurring || false;
            state.catalogentry.trigger = catalogentry.trigger || 'manual';
            state.catalogentry.function = catalogentry.function || '';
        }
    },

    updateAlgorythm(state, algorythm) {
        state.catalogentry = Object.assign({}, state.catalogentry, {
            algorythm: algorythm,
            function: algorythm == "custom" ? DEFAULT_CUSTOM_ALGORYTHMS.default : state.catalogentry.commitment,
            unit_amount: algorythm == "custom" ? null : state.catalogentry.unit_amount
        })
    },

    updateRecurring(state, recurring) {
        state.catalogentry = Object.assign({}, state.catalogentry, {
            recurring: recurring,
            saf: recurring ? null : state.catalogentry.saf,
            commitment: recurring ? null : state.catalogentry.commitment,
        });
    },

    updateCategory(state, category) {
        state.catalogentry = Object.assign({}, state.catalogentry, {
            category: category
        });
    },

    updateTrigger(state, trigger) {
        state.catalogentry = Object.assign({}, state.catalogentry, {
            trigger: trigger,
            algorythm: trigger == "manual" ? "fixed" : state.catalogentry.algorythm
        });
    },

    updateVatRate(state, vat_rate) {
        state.catalogentry = Object.assign({}, state.catalogentry, {
            vat_rate: vat_rate
        });
    },

    updateMarkup(state, markup) {
        state.catalogentry = Object.assign({}, state.catalogentry, {
            markup: markup
        });
    },

    useTemplate(state) {
        state.catalogentry = Object.assign({}, state.catalogentry, {
            function: DEFAULT_CUSTOM_ALGORYTHMS[state.catalogentry.trigger]
        });
    },

    useEmptyTemplate(state) {
        state.catalogentry = Object.assign({}, state.catalogentry, {
            function: DEFAULT_CUSTOM_ALGORYTHMS["default"]
        });
    },

    updateLabel(state, label) {
        state.catalogentry = {
            ...state.catalogentry, ...{
                label: label,
                code: state.catalogentry.id ? state.catalogentry.code : slugify(label || ""),
            }
        };
    },

    updateCategories(state, categories) {
        state.categories = categories;
    },
    updateCategoriesLoading(state, loading) {
        state.categories_loading = loading;
    },
    updateCategoriesLoadingErrors(state, errors) {
        state.categories_loading_errors = errors;
    },

};

const actions = {

    async fetchCatalog({ commit, dispatch, state }, params) {
        commit('updateCatalogLoading', true);
        commit('updateCatalogLoadingErrors', null);

        let url;
        if (params && params.id) {
            url = `/api/catalogs/${params.id}/`;
        } else if (state.catalog) {
            url = `/api/catalogs/${state.catalog.id}/`;
        } else {
            throw 'No catalog to fetch';
        }

        try {
            const response = await axios.get(url);
            commit('updateCatalogLoading', false);
            commit('updateCatalog', response.data);
            if (params && params.callback) {
                params.callback({ success: true, response: response.data });
            }
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit('updateCatalogLoading', false);
            commit('updateCatalogLoadingErrors', error.details);
            if (params && params.callback) {
                params.callback(error);
            }
        }
    },

    async fetchCatalogEntry({ commit, dispatch, state }, params) {
        commit('updateCatalogEntryLoading', true);
        commit('updateCatalogEntryLoadingErrors', null);
        try {
            let url;
            if (params && params.id) {
                url = `/api/catalogentries/${params.id}/`;
            } else if (state.catalog) {
                url = `/api/catalogentries/${state.catalogentry.id}/`;
            } else {
                throw 'No catalogentry to fetch';
            }
            const response = await axios.get(url);
            commit('updateCatalogEntryLoading', false);
            commit('updateCatalogEntry', response.data);
            return response.data;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit('updateCatalogEntryLoading', false);
            commit('updateCatalogEntryLoadingErrors', error.details);
            throw error;
        }
    },

    async setCatalogReadyness({ commit, dispatch, state }, params) {
        const url = `/api/catalogs/${params.catalog.id}/ready/`;
        try {
            const response = await axios.put(url, { ready: params.ready });
            if (params && params.callback) {
                params.callback({ success: true, response: response.data });
            }
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            if (params && params.callback) {
                params.callback(error);
            }
        }
    },

    async deleteCatalog({ commit, dispatch, state }, params) {
        commit('updateCatalogDeleting', true);
        commit('updateCatalogDeletingErrors', null);
        try {
            const url = `/api/catalogs/${params.instance.id}/archive/`;
            const response = await axios.post(url);
            commit('updateCatalogDeleting', false);
            return response;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit('updateCatalogDeleting', false);
            commit('updateCatalogDeletingErrors', error.details);
            throw error;
        }
    },

    async archiveCatalogEntry({ commit, dispatch, state }, params) {
        commit('updateCatalogEntryArchiving', true);
        commit('updateCatalogEntryArchivingErrors', null);
        try {
            const url = `/api/catalogentries/${params.instance.id}/archive/`;
            const response = await axios.post(url);
            commit('updateCatalogEntryArchiving', false);
            dispatch('fetchCatalog');
            return response.data;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit('updateCatalogEntryArchiving', false);
            commit('updateCatalogEntryArchivingErrors', error.details);
            throw error;
        }
    },

    async setCatalogEntryStatus({ commit, dispatch, state }, params) {
        try {
            const url = `/api/catalogentries/${params.catalogentry.id}/status/`;
            const data = { status: params.status };
            if (params.received_count) {
                data.received_count = params.received_count;
            }
            const response = await axios.put(url, data);
            return response;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            throw error;
        }
    },

    async saveCatalog({ commit, dispatch, state }, params) {
        commit('updateCatalogSaving', true);
        commit('updateCatalogSavingErrors', null);
        try {
            let url = '/api/catalogs/';
            let method = axios.post;
            if (params.instance.id) {
                url = `/api/catalogs/${params.instance.id}/`;
                method = axios.put;
            }
            const response = await method(url, params.instance);
            commit('updateCatalogSaving', false);
            return response;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit('updateCatalogSavingErrors', error.details);
            throw error;
        }
    },

    async saveCatalogEntry({ commit, dispatch, state }, params) {
        commit('updateCatalogEntrySaving', true);
        commit('updateCatalogEntrySavingErrors', null);
        try {
            let url = '/api/catalogentries/';
            let method = axios.post;
            if (params.instance.id) {
                url = `/api/catalogentries/${params.instance.id}/`;
                method = axios.put;
            }
            if (params.params) {
                const queryparams = qs.stringify(params.params, { arrayFormat: 'repeat' });
                if (queryparams) {
                    url += `?${queryparams}`;
                }
            }
            const response = await method(url, params.instance);
            commit('updateCatalogEntrySaving', false);
            return response;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit('updateCatalogEntrySaving', false);
            commit('updateCatalogEntrySavingErrors', error.details);
            throw error;
        }
    },

    async fetchCatalogEntries({ commit, dispatch, state }, params) {
        commit('updateCatalogEntriesLoading', true);
        commit('updateCatalogEntriesLoadingErrors', null);

        try {
            const response = await axios.get('/api/catalogentries/', {
                params: migrateCatalogEntryFormatFilter(state.catalogentries_filters),
            });
            commit('updateCatalogEntries', response.data.results);
            commit('updateCatalogEntriesCount', response.data.count);
            return response;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit('updateCatalogEntriesLoadingErrors', error.details);
            throw error;
        } finally {
            commit('updateCatalogEntriesLoading', false);
        }
    },



    async fetchCategories({ commit, dispatch, state }, params) {
        commit('updateCategoriesLoading', true);
        commit('updateCategoriesLoadingErrors', null);

        try {
            const response = await axios.get('/api/catalogcategories/', { params: state.categories_filters });
            commit('updateCategories', response.data);
            return response;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit('updateCategoriesLoadingErrors', error.details);
            throw error;
        } finally {
            commit('updateCategoriesLoading', false);
        }
    },



    async fetchTestShipments({ commit, dispatch, state }, params) {
        commit('updateTestShipmentsLoading', true);
        commit('updateTestShipmentsLoadingErrors', null);
        try {
            const response = await axios.get('/api/shipments/', { params: { limit: 20, ordering: '-creation_date' } });
            commit('updateTestShipments', response.data.results);
            return response;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit('updateTestShipmentsLoadingErrors', error.details);
            throw error;
        } finally {
            commit('updateTestShipmentsLoading', false);
        }
    },

    async fetchTestReceipts({ commit, dispatch, state }, params) {
        commit('updateTestReceiptsLoading', true);
        commit('updateTestReceiptsLoadingErrors', null);
        try {
            const response = await axios.get('/api/receipts/', { params: { limit: 20, ordering: '-receipt_date' } });
            commit('updateTestReceipts', response.data.results);
            return response;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit('updateTestReceiptsLoadingErrors', error.details);
            throw error;
        } finally {
            commit('updateTestReceiptsLoading', false);
        }
    },

    async testFunction({ commit, dispatch, state }, params) {
        commit('updateTestingFunction', true);
        try {
            const url = `/api/catalogentries/${params.catalogentry_id}/testfunction/`;
            const response = await axios.post(url, { params: state.test_params, trigger: params.trigger, function: params.function });
            return response.data;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            throw error;
        } finally {
            commit('updateTestingFunction', false);
        }
    },

    async generateCode({ commit, dispatch, state }, params) {
        commit('updateGeneratingCode', true);
        try {
            const url = state.catalogentry.id
                ? `/api/catalogentries/${state.catalogentry.id}/generatecode/`
                : "/api/catalogentries/generate-algorithm/";
            const response = await axios.post(url, {
                catalog: state.catalogentry.catalog,
                trigger: state.catalogentry.trigger,
                prompt: params.prompt,
                current_function: state.catalogentry.function || "",
            }, { timeout: 90000 });
            return response.data;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            throw error;
        } finally {
            commit('updateGeneratingCode', false);
        }
    },

    init({ commit, dispatch, state }, params) {
        commit('updateCatalogEntry', params.catalogentry);
        dispatch('fetchCategories');
    },


    async fetchProducts({ commit, dispatch, state }, params) {
        commit('updateProductsLoading', true);
        try {
            const response = await axios.get('/api/products/', { params: { limit: 10, search: state.products_search } });
            commit('updateProducts', response.data.results);
            return response;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit('updateProductsLoadingErrors', error.details);
            throw error;
        }
    },
    changeProductSearch({ commit, dispatch, state }, search) {
        commit('updateProductsSearch', search);
        dispatch('fetchProducts');
    },
};


export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
